import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=55b15a56&scoped=true&"
import script from "./Me.vue?vue&type=script&lang=js&"
export * from "./Me.vue?vue&type=script&lang=js&"
import style0 from "./Me.vue?vue&type=style&index=0&id=55b15a56&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b15a56",
  null
  
)

export default component.exports